import { useRef, useState } from "react";

export const useSlidesWidth = (slidesCount: number) => {
  const [isAllSlidesMeasured, setIsAllSlidesMeasured] = useState(false);

  const slidesWidthRef = useRef<number[]>([]);
  const slideRefs = useRef<HTMLElement[]>([]);

  const setSlideRef = (node: HTMLElement | null, index: number) => {
    if (!node) {
      return;
    }

    slideRefs.current[index] = node;

    if (typeof slidesWidthRef.current[index] !== "number") {
      const intersectionObserver = new ResizeObserver(([entry]) => {
        const { width: slideWidth } = entry.contentRect;

        if (slideWidth != null && slideWidth > 0) {
          slidesWidthRef.current[index] = slideWidth;
        }

        setIsAllSlidesMeasured(
          slidesWidthRef.current.filter(Boolean).length === slidesCount
        );
      });

      intersectionObserver.observe(node);
    }
  };

  return { isAllSlidesMeasured, slidesWidthRef, slideRefs, setSlideRef };
};
